export default "__VITE_ASSET__9cfaf05a__"